import type React from "react";

interface LoaderSpinnerProps {
  isLoading?: boolean;
  fallback?: React.ReactNode;
}

export const LoaderSpinner: React.FC<React.PropsWithChildren<LoaderSpinnerProps>> = ({
  children,
  isLoading,
  fallback,
}) => {
  if (isLoading) {
    // oxlint-disable-next-line react/jsx-no-useless-fragment -- fragment narrows the node to a valid JSX return
    if (fallback) return <>{fallback}</>;
    return (
      <div className="flex size-full items-center justify-center">
        <div className="loading-spinner size-7 text-brand" />
      </div>
    );
  }

  // oxlint-disable-next-line react/jsx-no-useless-fragment -- fragment narrows the node to a valid JSX return
  return <>{children}</>;
};
